export function getSafeMarkdownHref(href: string | undefined) {
  if (!href) {
    return undefined;
  }

  const trimmed = href.trim();
  const normalized = trimmed.toLowerCase();

  if (trimmed.startsWith('#')) {
    return trimmed;
  }

  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
    return trimmed;
  }

  if (
    normalized.startsWith('http://') ||
    normalized.startsWith('https://') ||
    normalized.startsWith('mailto:')
  ) {
    return trimmed;
  }

  return undefined;
}

export function isExternalMarkdownHref(href: string | undefined) {
  if (!href) {
    return false;
  }

  const normalized = href.trim().toLowerCase();
  return normalized.startsWith('http://') || normalized.startsWith('https://');
}
